import React, { Component } from "react";

import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
// import Col from 'react-bootstrap/Col';
// import Row from 'react-bootstrap/Row';
//import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';



//photos
import instructorArt from '../../images/instructors/instructor-art-winter.jpg';
// import instructorVik from '../../images/instructors/instructor-vik.jpg';

class Instructors extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
        //this.props.history.push("/instructors");
    }

    render() {

        return (
            <div className="h-100">


                <Container>
                    <Navbar expand="lg" variant={this.state.variant} bg={this.state.variant} className="m-3">
                        <Container>
                            <Navbar.Brand style={{ fontSize: '36px' }}>About Me</Navbar.Brand>
                        </Container>
                    </Navbar>

                    <div className="d-md-flex justify-content-start align-items-start">
                        <div className="p-3">
                            <Image className="img-fluid"  src={instructorArt} alt="Art Fiedler" 
                                >
                            </Image>
                        </div>
                        <div className="p-3" style={{ minWidth: '400px' }}>
                            <h3>Art Fiedler</h3>
                            <p>
                                My name is Arthur/Art, and I'm originally from Thunder Bay. In my 20s, I lived in Toronto & Vancouver, before jetting off traveling to find a new path and career.
                                I joked about how it was my Eat, Pray, Love journey — although if you would've told me I'd be a full-time yoga teacher living in my hometown, I never would've believed you.
                            </p>
                            <p>
                                And yes I've made a lot of mistakes — but I'm taking these lessons and learning (sometimes slowly😂). I want to thank everyone who has guided/supported my journey,
                                taught me lessons, and held the space for my growth. You know who you are.
                            </p>
                            <p>
                                I love what I do. I love where I live. I love my family, friends, & community. I love sharing the beautiful simplicity of yoga.
                            </p>
                            <p>
                                If we haven't met yet, maybe I'll see you on a mat sometime soon. There is no judgement/expectation/pressure in yoga — we are learning to reconnect with ourselves,
                                without the distractions and stimulations of our busy lives.
                            </p>
                            <p>
                                So perhaps I'll see you in the studio, the hole, the sauna, or on a dance floor near you!
                            </p>
                        </div>
                    </div>
                    {/* <Row className="py-3">
                        <Col>
                            <Image fluid rounded src={instructorVik} alt="Art Fiedler" className="img-thumbnail"
                                style={{
                                    marginLeft: 'auto', marginRight: 'auto', minHeight: '428.5px', minWidth: '342.5px',
                                    maxHeight: '428.5px', maxWidth: '342.5px', display: 'block', border: '0px', objectFit: 'cover'
                                }}>
                            </Image>
                        </Col>
                        <Col style={{ minWidth: '400px' }}>
                            <h3>Vik Wilen</h3>
                            <p>
                                I have been practicing yoga since I was 18, after experiencing my first guided yoga class in a Tree Planting camp in NW Ontario.
                                I am trained in a Canadian based yoga lineage called “Modo yoga”, as well as vinyasa and freestyle flow.
                            </p>
                            <p>
                                Before the pandemic, I taught consistently for 8 years and would describe my classes as fast paced and powerful.
                                As I have grown in my own practice, I now prefer to slow things down, using more intentional and mindful movements.
                            </p>
                            <p>
                                I look forward to bringing you a sense of calm and creativity to the mat!!
                            </p>
                        </Col>
                    </Row> */}


                </Container>
            </div>
        );
    }
}

export default Instructors;